module.exports = __webpack_public_path__ + "img/大图.a0dd7860.png";